var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 30.9813C55 44.2464 44.2464 55 30.9813 55C17.7161 55 6.9625 44.2464 6.9625 30.9813C6.9625 17.7161 17.7161 6.9625 30.9812 6.9625C44.2464 6.9625 55 17.7161 55 30.9813Z",
    fill: "#0C9347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25L28 30.5L34 36",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleLeft);
export default __webpack_public_path__ + "static/media/ArrowCircleLeft.31cea1c5ec798ae01ef8f5e39dfa5603.svg";
export { ForwardRef as ReactComponent };